import React from 'react';
import { Skeleton } from './skeleton';

interface ShimmerLoaderProps {
  className?: string;
  lines?: number;
  height?: string;
}

export const ShimmerLoader: React.FC<ShimmerLoaderProps> = ({
  className = '',
  lines = 1,
  height = 'h-4',
}) => {
  return (
    <div className={`space-y-2 ${className}`}>
      {Array.from({ length: lines }).map((_, index) => (
        <Skeleton
          key={index}
          className={`${height} ${index === lines - 1 ? 'w-3/4' : 'w-full'}`}
        />
      ))}
    </div>
  );
};
